import { UtenteVO } from "./utenteVO";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";
import {ListaVisibilitaVO} from "@vo/lista-visibilita/lista-visibilitaVO";
import {SettoreVO} from "@vo/settoreVO";
import {SoggettoEsternoVO} from "@vo/soggetto-esternoVO";

export class VisibilitaFascicoloVO {
  dataInizioVisibilita: string;
  dataFineVisibilita: string;
  operatore: UtenteVO;
  utente: UtenteVO;
  settore: SettoreVO;
  gruppoVisibilita: ListaVisibilitaVO;
  soggettoEsterno: SoggettoEsternoVO;
  tipoVisibilita: TipoVisibilitaEnum;

}
